/// <amd-module name="TFS/Admin/Views/OrganizationPolicies/Sources/OrganizationPoliciesSource" />
import AdminResources = require("TFS/Admin/Views/OrganizationPolicies/Resources");
import { PolicyType, Policy, SourceConstants } from "TFS/Admin/Views/OrganizationPolicies/Contracts/DataModels";
import { getOrganizationPolicyClient } from "TFS/Admin/Common/RestClient/OrganizationPolicy";
import { getOrganizationClient } from "TFS/Admin/Common/RestClient/Organization";
import { IVssPageContext } from "VSS/Platform/Context";
import { JsonPatchDocument, JsonPatchOperation, Operation } from "VSS/Platform/Contracts/WebApi";

export class OrganizationPoliciesSource {
    public getPolicyTitleText(policyType: PolicyType): string | undefined {
        switch (policyType) {
            case "applicationConnection":
                return AdminResources.ApplicationConnectionPolicies;
            case "directory":
                return AdminResources.DirectoryPolicies;
            case "security":
                return AdminResources.SecurityPolicies;
            case "workItemLinking":
                return AdminResources.WorkItemLinkingPolicies;
            case "user":
                return AdminResources.UserPolicies;
        }
        return policyType;
    }
    public updatePolicy(pageContext: IVssPageContext, policy: Policy, invertedPolicies: string[]): Promise<void> {
        const policyClient = getOrganizationPolicyClient(pageContext);
        let createPatchDocument = (): JsonPatchDocument => {
            let operations: JsonPatchOperation[] = [];
            operations.push({
                from: "",
                op: Operation.Replace,
                path: SourceConstants.VALUE_PATH,
                value: this.handleInvertedPolicies(policy, invertedPolicies).toString()
            } as JsonPatchOperation);
            return operations as JsonPatchDocument;
        };
        return policyClient.updatePolicy(createPatchDocument(), policy.name);
    }

    public updateProperties(pageContext: IVssPageContext, requestAccessUrl: string, collectionId: string): Promise<boolean> {
        const organizationClient = getOrganizationClient(pageContext);
        let createPatchDocument = (): JsonPatchDocument => {
            let operations: JsonPatchOperation[] = [];

            if (requestAccessUrl !== null) {
                operations.push({
                    from: "",
                    op: Operation.Replace,
                    path: SourceConstants.REQUEST_ACCESS_URL_PATH,
                    value: requestAccessUrl
                } as JsonPatchOperation);
            }
            return operations as JsonPatchDocument;
        };
        return organizationClient.updateCollectionProperties(collectionId, createPatchDocument());
    }

    private handleInvertedPolicies(originalPolicy: Policy, invertedPolicies: string[]): boolean {
        if (invertedPolicies && invertedPolicies.indexOf(originalPolicy.name) != -1) {
            return !(<boolean>originalPolicy.effectiveValue);
        }
        return originalPolicy.effectiveValue;
    }
}
